import { Outlet } from "react-router-dom";
import SideMenuBar from "../sideBar/SideMenuBar";
import "./AppLayout.scss";
import React, { useEffect } from "react";
import NavBar from "../navBar/Navbar";
import FilterBar from "../filter/FilterBar";
import { observer } from "mobx-react-lite";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const AppLayout = ({ filter = true }) => {
  // const { instance } = useMsal();
  // useEffect(() => {
  //   instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  // }, []);

  return (
    <AuthenticatedTemplate>
      <div data-testid={"app-layout"} className="layout">
        <SideMenuBar />
        <div className="outlet">
          <div >
            <NavBar />
          </div>
          {filter && (
            <div>
              <FilterBar />
            </div>
          )}
                    <div style={{paddingTop: filter? '30px': '0px'}}>

            <Outlet />
          </div>
        </div>
      </div>
      {/*aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa*/}
    </AuthenticatedTemplate>
  );
};

export default observer(AppLayout);
